// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/app-system-schema',
  type: 'object',
  required: ['id'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    name: {
      type: 'string',
      nullable: true,
    },
    tenantKey: {
      type: 'string',
      nullable: true,
    },
    isActive: {
      type: 'boolean',
    },
    caption: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
